export default function DialogModal({ isOpen, onBackdropClick, children, position = "fixed" }) {
  if (!isOpen) return null;
  return (
    <div
      className={`${position} inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center px-6`}
      onClick={onBackdropClick}
    >
      <div onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}
